import { Dispatch, AnyAction } from 'redux';

import { TwilioClient } from 'ha/types/Twilio';
import { AppServices } from 'ha/services/getAppServices';
import { NetworkError } from '../types';

export default (debug: boolean = false) => (
  _: Dispatch<AnyAction>,
  __: () => void,
  { apiV2, twilio }: AppServices,
): Promise<TwilioClient> =>
  apiV2.getRealtimeToken('me').then(({ data, status }) => {
    if (data && data.token) {
      return twilio.init(data.token, { debug });
    }

    const err = new Error('Twilio Token is not provided') as NetworkError;

    err.status = status;

    return Promise.reject(err);
  });
